import { ApolloClient, InMemoryCache, gql } from "@apollo/client";
import StorageService from "../../util/storage";
import { getOrganisationId } from "../organisations/organisationsSlice";

const client = new ApolloClient({
    uri: `${process.env.REACT_APP_BACKEND_URL}/graphql`,
    cache: new InMemoryCache(),
    headers: {
        Authorization: `${StorageService.getItem("bearer")}`,
    },
});

export const fetchProducts = async () => {
    const orgId = await getOrganisationId();

    const query = gql`
        query GetProducts($orgId: String!) {
            courses(filters: { organisation: { orgId: { eq: $orgId } }, publishedAt: { ne: null } }, pagination: { limit: 1000 }) {
                data {
                    id
                    attributes {
                        Title
                        Summary
                        Description
                        Cover {
                            data {
                                attributes {
                                    url
                                }
                            }
                        }

                        categories {
                            data {
                                attributes {
                                    name
                                }
                            }
                        }
                        Lessons {
                            ... on ComponentCoursesLessons {
                                id
                                title
                                description
                                preview
                            }
                            ... on ComponentCoursesEmbed {
                                id
                                title
                                embedURL
                                timer
                            }
                            ... on ComponentCoursesQuizzes {
                                id
                                title
                            }
                            ... on Error {
                                code
                                message
                            }
                        }
                        course_price {
                            data {
                                id
                                attributes {
                                    memberPrice
                                    nonMemberPrice
                                    Promotion {
                                        memberPrice
                                        nonMemberPrice
                                        promoMessage
                                        expiration
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `;
    const { data } = await client.query({
        query,
        variables: { orgId: orgId },
    });
    return data.courses.data;
};

export const fetchProduct = async (id) => {
    const query = gql`
        query GetProduct($id: ID!) {
            course(id: $id) {
                data {
                    id
                    attributes {
                        Title
                        Summary
                        Description
                        Cover {
                            data {
                                attributes {
                                    url
                                }
                            }
                        }

                        categories {
                            data {
                                attributes {
                                    name
                                }
                            }
                        }
                        Lessons {
                            ... on ComponentCoursesLessons {
                                id
                                title
                                description
                                preview
                            }
                            ... on ComponentCoursesEmbed {
                                id
                                title
                                embedURL
                                timer
                            }
                            ... on ComponentCoursesFile {
                                title
                                file {
                                    data {
                                        id
                                        attributes {
                                            name
                                            url
                                            previewUrl
                                        }
                                    }
                                }
                                timer
                            }
                            ... on ComponentCoursesQuizzes {
                                id
                                title
                                passingThreshhold
                                maxRetryAttempts
                                questions {
                                    id
                                    title
                                    type
                                    points
                                    description
                                    hint
                                    answers {
                                        id
                                        Answer
                                        Correct
                                    }
                                }
                            }
                            ... on Error {
                                code
                                message
                            }
                        }
                        course_price {
                            data {
                                id
                                attributes {
                                    memberPrice
                                    nonMemberPrice
                                    Promotion {
                                        memberPrice
                                        nonMemberPrice
                                        promoMessage
                                        expiration
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `;
    const { data } = await client.query({
        query,
        variables: { id },
    });

    return data.course.data;
};

export const saveProgress = async (id, data) => {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/driver-products/${id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: StorageService.getItem("bearer"),
        },
        body: JSON.stringify({ data }),
    });

    if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
    }

    return response;
};
